import React, { useState } from 'react';
import { Camera, X } from 'lucide-react';
import { Button } from '../ui/button';

const TARGET = 3;
const SNOOZE_KEY = 'zuriya_portfolio_prompt_snoozed_until';
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

function snoozed() {
  try { return Number(window.localStorage.getItem(SNOOZE_KEY) || 0) > Date.now(); } catch { return false; }
}

// Nudges providers with fewer than 3 portfolio photos; dismissable for a week.
export function PortfolioPhotoPrompt({ count, setActiveTab }) {
  const [hidden, setHidden] = useState(snoozed);
  if (count >= TARGET || hidden) return null;

  const dismiss = () => {
    try { window.localStorage.setItem(SNOOZE_KEY, String(Date.now() + WEEK_MS)); } catch { /* private mode */ }
    setHidden(true);
  };
  const left = TARGET - count;

  return (
    <div className="card-surface p-5 mb-6 flex items-start gap-4 border-l-4 border-l-[#D4AF37]" data-testid="portfolio-photo-prompt">
      <div className="w-10 h-10 shrink-0 rounded-full bg-[#F9F6F0] flex items-center justify-center">
        <Camera className="h-5 w-5 text-[#D4AF37]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-medium text-[#1A1A1A]">Get your work on the Zuriya homepage</p>
        <p className="text-sm text-stone-500 mt-1">
          We feature real provider photos on our homepage. Add {left} more portfolio {left === 1 ? 'photo' : 'photos'} so
          we can choose your best work, and so clients can see what you do before they book.
        </p>
        <Button size="sm" className="btn-primary mt-3" onClick={() => setActiveTab('portfolio')} data-testid="portfolio-photo-prompt-upload">
          Add photos
        </Button>
      </div>
      <button onClick={dismiss} className="text-stone-400 hover:text-stone-600" aria-label="Hide for a week" data-testid="portfolio-photo-prompt-dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
